import { combineReducers } from "redux";
import loginReducer from "../components/user/reducers";
import regionReducer from "../components/region/reducers";
import siteReducer from "../components/site/reducers";
import projectReducer from "../components/project/reducers";
import buildingReducer from "../components/building/reducers";
import recommendationsReducer from "../components/recommendations/reducers";
import floorReducer from "../components/floor/reducers";
import buildingTypeReducer from "../components/buildingtype/reducers";
import commonReducer from "../components/common/reducers";
import tradeReducer from "../components/trade/reducers";
import categoryReducer from "../components/category/reducers";
import departmentReducer from "../components/department/reducers";
import systemReducer from "../components/system/reducers";
import subsystemReducer from "../components/subsystem/reducers";
import generalsettingReducer from "../components/generalsetting/reducers";
import fundingsourceReducer from "../components/fundingsource/reducers";
import prioritysettingReducer from "../components/prioritysetting/reducers";
import clientReducer from "../components/client/reducers";
import userReducer from "../components/users/reducers";
import assetconditionReducer from "../components/assetcondition/reducers";
import userPermissionReducer from "../components/userPermissions/reducers";
import consultancyReducer from "../components/consultancy/reducers";
import dashboardReducer from "../components/dashboard/reducers";
import templateReducer from "../components/template/reducers";
import initativeReducer from "../components/initiatives/reducers";
import reportReducer from "../components/documents/reducers";
import fcaReportReducer from "../components/reports/reducers";
// import globalSettingsReducer from "../components/globalSettings/reducers";
import narrativeTemplateReducer from "../components/narrativeTemplate/reducers";
import specialReportReducer from "../components/special_report/reducers";
import reportParagraphReducer from "../components/report_paragraph/reducers";
import childParagraphReducer from "../components/child_paragraph/reducers";
import chartsAndGraphsReducer from "../components/charts_and_graphs/reducers";
import systemTablesReducer from "../components/system_tables/reducers";
import tableTemplateReducer from "../components/tableTemplate/reducers";
import reportNoteTemplateReducer from "../components/reportNoteTemplate/reducers";
import masterTradeReducer from "../components/master_trade/reducers";
import masterSystemReducer from "../components/master_system/reducers";
import masterSubSystemReducer from "../components/master_subsystem/reducers";
import helperReducer from "../components/helper/reducers";
import logReducer from "../components/log/reducers";
import reportPropertyReducer from "../components/reportProperties/reducers";
import reportTemplateReducer from "../components/reportTemplates/reducers";
import buildingAdditionReducer from "../components/buildingAddition/reducers";
import imageReducer from "../components/images/reducers";
import assetReducer from "../components/assets/reducers";
import assetSettingsReducer from "../components/assetSettings/reducers";
import propertyValueReducer from "../components/reportPropertyValues/reducers";
import recommendationTemplateReducer from "../components/recommendationTemplate/reducers";
import meterReducer from "../components/meterManagement/reducers";
import energyManagmentReducer from "../components/energyManagment/reducers";
import electricReducer from "../components/electricity/reducers";
import waterReducer from "../components/water/reducers";
import sewerReducer from "../components/sewer/reducers";
import gasReducer from "../components/gas/reducers";
import accountReducer from "../components/accounts/reducers";
import chartEnergyReducer from "../components/chartEnergyTemplate/reducers";
import assetManagementReducer from "../components/assetManagement/reducers";
import assetDashboardReducer from "../components/assetDashboard/reducers";
import energyStarReducer from "../components/energyStar/reducers";
import documentSettingsReducer from "../components/documentSettings/reducers";
import chartTemplateReducer from "../components/chartTemplates/reducers";
import chartPropertyReducer from "../components/chartProperties/reducers";
import manageHeadingReducer from "../components/manageHeadings/reducers";
import capitalTypeReducer from "../components/capitalType/reducers";
import masterCapitalTypeReducer from "../components/capitalTypeGroup/reducers";
import emailReducer from "../components/email/reducers";
import notificationReducer from "../components/notification/reducers";
import smartChartReducer from "../components/smartCharts/reducer";
import softCostReducer from "../components/softCosts/reducers";
import responsibilityReducer from "../components/responsibility/reducers";
import recommendationAcceptableVerbReducer from "../components/recommendationAcceptableVerbs/reducers";
import capitalRequestReducer from "../components/capitalRequest/reducers";
import dynamicFieldReducer from "../components/dynamicFieldSettings/reducers";
import dynamicTableReducer from "../components/dynamicTables/reducers";
import medianReducer from "../components/medianManagement/reducer";
import { UPDATE_DEFAULT_PROJECT } from "../components/dashboard/constants";
import { LOGOUT_SUCCESS } from "../components/user/constants";
import shiftCspHistoryReducer from "../components/shiftCspHistory/reducers";
import { CR_USER_LOGOUT_SUCCESS } from "../components/capitalRequest/constants";
import assetSurveyProjectReducer from "../components/assetSurveyProject/reducers";
import surveyTemplateReducer from "../components/assetSurveyTemplate/reducers";
import assetSurveySettingsReducer from "../components/assetSurveySettings/reducers";
import mobileRecommendationsReducer from "../components/mobileRecommendation/reducers";
import mobileRecommendationTemplatesReducer from "../components/mobileRecommendationTemplates/reducers";
import recommendationStatusReducer from "../components/Status/reducer";
import BuildingAgeCategories from "../components/buildingAgeCategories/reducer";
import StopLightChartReducer from "../components/stopLightChart/reducer";
import groupStatusReducer from "../components/statusGroup/reducer";
import systemTopNColorReducer from "../components/topNColorTable/reducer";
import leaseBuildingReducer from "../components/buildingLease/reducers";
import surveyorReducer from "../components/surveyorProfiles/reducer";
import projectSettingsTemplateReducer from "../components/projectSettingsTemplate/reducer";
import masterProjectSettingsTemplateReducer from "../components/masterProjectSettings/reducer";
import spaceTypeReducer from "../components/spaceType/reducer";
import taskManagerReducer from "../components/taskManager/reducers";
import assetConditionIndexColorReducer from "../components/assetConditionIndexColor/reducers";
import chartCategorySettingsReducer from "../components/chartCategorySettings/reducers";
const rootReducer = combineReducers({
    loginReducer,
    regionReducer,
    siteReducer,
    buildingReducer,
    projectReducer,
    recommendationsReducer,
    floorReducer,
    commonReducer,
    buildingTypeReducer,
    tradeReducer,
    categoryReducer,
    departmentReducer,
    systemReducer,
    subsystemReducer,
    generalsettingReducer,
    fundingsourceReducer,
    prioritysettingReducer,
    clientReducer,
    userReducer,
    assetconditionReducer,
    userPermissionReducer,
    consultancyReducer,
    dashboardReducer,
    templateReducer,
    initativeReducer,
    reportReducer,
    fcaReportReducer,
    // globalSettingsReducer,
    narrativeTemplateReducer,
    tableTemplateReducer,
    reportNoteTemplateReducer,
    masterTradeReducer,
    masterSystemReducer,
    masterSubSystemReducer,
    helperReducer,
    logReducer,
    reportPropertyReducer,
    reportTemplateReducer,
    buildingAdditionReducer,
    imageReducer,
    assetReducer,
    assetSettingsReducer,
    specialReportReducer,
    reportParagraphReducer,
    childParagraphReducer,
    chartsAndGraphsReducer,
    systemTablesReducer,
    propertyValueReducer,
    recommendationTemplateReducer,
    meterReducer,
    energyManagmentReducer,
    electricReducer,
    waterReducer,
    sewerReducer,
    gasReducer,
    accountReducer,
    chartEnergyReducer,
    assetManagementReducer,
    assetDashboardReducer,
    energyStarReducer,
    documentSettingsReducer,
    chartTemplateReducer,
    chartPropertyReducer,
    manageHeadingReducer,
    capitalTypeReducer,
    masterCapitalTypeReducer,
    emailReducer,
    notificationReducer,
    smartChartReducer,
    softCostReducer,
    capitalRequestReducer,
    responsibilityReducer,
    recommendationAcceptableVerbReducer,
    dynamicFieldReducer,
    dynamicTableReducer,
    medianReducer,
    shiftCspHistoryReducer,
    assetSurveyProjectReducer,
    surveyTemplateReducer,
    assetSurveySettingsReducer,
    mobileRecommendationsReducer,
    mobileRecommendationTemplatesReducer,
    recommendationStatusReducer,
    BuildingAgeCategories,
    StopLightChartReducer,
    groupStatusReducer,
    systemTopNColorReducer,
    surveyorReducer,
    leaseBuildingReducer,
    projectSettingsTemplateReducer,
    masterProjectSettingsTemplateReducer,
    spaceTypeReducer,
    taskManagerReducer,
    assetConditionIndexColorReducer,
    chartCategorySettingsReducer
});

const AppReducer = (state, action) => {
    if (action.type === LOGOUT_SUCCESS || action.type === UPDATE_DEFAULT_PROJECT || action.type === CR_USER_LOGOUT_SUCCESS) {
        const PRESERVED_MENU_RESPONSES = [
            "getProjectMenuItemsResponse",
            "getProjectRegionMenuItemsResponse",
            "getProjectSiteMenuItemsResponse",
            "getProjectBuildingMenuItemsResponse",
            "getProjectFloorMenuItemsResponse",
            "getEfciMenuItemsResponse",
            "getEfciRegionMenuItemsResponse",
            "getEfciSiteMenuItemsResponse",
            "getEfciBuildingMenuItemsResponse",
            "getRegionMenuItemsResponse",
            "getUserByIdResponse"
        ];
        const preservedMenuData = {};
        PRESERVED_MENU_RESPONSES.forEach(key => {
            if (state?.commonReducer?.[key]) {
                preservedMenuData[key] = state.commonReducer[key];
            }
        });
        if (action.payload?.fromSideMenu === true) {
            const newState = rootReducer(undefined, action);
            return {
                ...newState,
                commonReducer: {
                    ...newState.commonReducer,
                    ...preservedMenuData
                }
            };
        } else return rootReducer(undefined, action);
    }
    return rootReducer(state, action);
};

export default AppReducer;
